import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Errors, LocalService, SellerService } from '../../../core';
import { PopupMessageService } from '../../../shared/message/services/message.service';

@Component({
  selector: 'app-prize-drawing-modal',
  templateUrl: './prize-drawing-modal.component.html',
  styleUrls: ['./prize-drawing-modal.component.scss'],
})
export class PrizeDrawingModalComponent {
  @Input() isOpen: boolean = false;
  @Input() ticket: any;
  @Output() close = new EventEmitter<void>();
  @Output() redeemed = new EventEmitter<any>();

  errors: Errors = { errors: {} };

  constructor(
    private sellerService: SellerService,
    private popupMessageService: PopupMessageService,
  ) {}

  closeModal() {
    this.close.emit();
  }

  redeemPrizeDrawing() {
    const ticket = this.ticket;
    ticket.disableAutoFlag = true;
    const userProfile = LocalService.get('userProfile');
    const params = {
      userId: userProfile.id,
      catalogItemId: ticket.id,
    };
    this.sellerService.redeemTicketCatalog(params).subscribe(
      (_data: any) => {
        const msg = 'Thank You!\nYou have successfully redeemed tickets for an entry into a contest drawing.';
        this.popupMessageService.showSuccess(msg, 'success');
        this.redeemed.emit(ticket);
      },
      (err: any) => {
        ticket.disableAutoFlag = false;
        this.errors = err;
      }
    );
  }
}
